import React from "react";
import {Stack, Image, Text, SimpleGrid} from "@chakra-ui/core";

import Content from "~/ui/structure/Content";
import {useTranslation} from "~/i18n/hooks";

const TechForPeople: React.FC = () => {
  const t = useTranslation();

  return (
    <Content paddingX={6} paddingY={{base: 12, md: 24}}>
      <SimpleGrid
        alignItems="center"
        columns={{base: 1, md: 2}}
        gridColumnGap={24}
        gridRowGap={12}
        justifyContent="space-between"
      >
        <Stack alignItems="flex-start" flex={1} maxWidth={640} spacing={8}>
          <Stack spacing={4}>
            <Text as="h3" color="primary.900" fontSize={{base: "xl", md: "2xl"}}>
              {t("aboutUs.expresion")}
            </Text>
          </Stack>
        </Stack>
        <Image flex={1} maxHeight={480} src="/assets/tech.svg" />
      </SimpleGrid>
    </Content>
  );
};

export default TechForPeople;
